// extracted by mini-css-extract-plugin
module.exports = {"atrias-logo":"style_atrias-logo__1063w","atrias-logo--clickable":"style_atrias-logo--clickable__2H5hy"};